"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var palette = _ref.palette,
    typography = _ref.typography;
  return {
    title: function title(props) {
      return {
        color: palette.primary.main,
        fontWeight: typography.fontWeightSemiBold,
        textTransform: 'uppercase',
        letterSpacing: '1.65px',
        lineHeight: '15px',
        margin: '0 0 10px 0',
        fontSize: '11px',
        textAlign: props.alignRight ? 'right' : undefined
      };
    }
  };
}, {
  name: 'SectionHeader'
});
exports.useStyles = useStyles;